<!-- Address Update Modal -->



<div
  *ngIf="Equitqble"
  class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
  id="modal-dialog"
>
  <div class="modal-content" id="modal-content">
    <div class="modal-header" id="backgroundColor">
      <h6 class="modal-title">{{ lang?.Equitable_Life }}</h6>
      <i
        class="bi bi-x-circle"
        role="button"
        aria-hidden="true"
        data-bs-dismiss="modal"
      ></i>
    </div>

    <div class="modal-body">
      <div>
        <iframe
          src="https://www.equitablehealth.ca/Account/Login?ReturnUrl=%2f"
          width="100%"
          id="pdf-viewer"
        >
        </iframe>
      </div>
    </div>
    <div class="modal-footer py-2">
      <button
        type="button"
        *ngIf="updatedWindowLenght > historyLength"
        id="previousButton"
        class="btn btn-sm btn-light"
        (click)="goBack()"
      >
        <b>Previous_Page</b>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-light"
        id="cancelButton"
        data-bs-dismiss="modal"
        data-bs-toggle="modal"
        (click)="close()"
      >
        <b>{{ lang?.Close }}</b>
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="Greenshild"
  class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
  id="modal-dialog"
>
  <div class="modal-content" id="modal-content">
    <div class="modal-header" id="backgroundColor">
      <h6 class="modal-title">{{ lang?.Greenshield }}</h6>
      <i
        class="bi bi-x-circle"
        role="button"
        aria-hidden="true"
        data-bs-dismiss="modal"
      ></i>
    </div>

    <div class="modal-body">
      <div>
        <iframe
          src="https://onlineservices.greenshield.ca/"
          width="100%"
          id="pdf-viewer"
        >
        </iframe>
      </div>
    </div>
    <div class="modal-footer py-2">
      <button
        type="button"
        *ngIf="updatedWindowLenght > historyLength"
        id="previousButton"
        class="btn btn-sm btn-light"
        (click)="goBack()"
      >
        <b>{{ lang?.Previous_Page }}</b>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-light"
        id="cancelButton"
        data-bs-dismiss="modal"
        data-bs-toggle="modal"
        (click)="close()"
      >
        <b>{{ lang?.Close }}</b>
      </button>
    </div>
  </div>
</div>

<div *ngIf="ENHCanada">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">ENHCanada</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>

      <div class="modal-body">
        <div>
          <iframe
            src="https://www.edgewoodhealthnetwork.com/"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="Alavida">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.ALAViDA }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>

      <div class="modal-body">
        <div>
          <iframe
            src="https://try.alavida.co/groupbenefitz"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>

      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="PhzioMSK360">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.Phzio_MSK360 }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>

      <div class="modal-body">
        <div>
          <iframe
            src="https://app.msk360.net/co/groupbenefitz"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>

      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>

        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="SolidGroundMethod">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.The_Solid_Ground_Method }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        <div>
          <iframe
            src="https://stressbusterseries.com/groupbenefitsregister"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>

        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="CloudMD">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.CloudMD_Kii }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>

      <div class="modal-body">
        <div>
          <iframe
            src="https://secure.kiihealth.ca/"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>

      <div class="modal-footer py-2">
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="previousButton"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>

        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="RxFood">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.RxFood }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>

      <div class="modal-body">
        <div>
          <iframe
            src="https://rxfood.co/register/groupbenefitz-en"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{lang?.Previous_Page}}</b>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
          (click)="close()"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="LifeSpeak">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.LifeSpeak }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>

      <div class="modal-body">
        <div>
          <iframe
            src="https://groupbenefitz.lifespeak.com"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>

      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>

        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="lifeSession">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.LIFT_Session }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        <div>
          <iframe
            src="https://groupbenefitz.liftsession.com/#/"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>

      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>

        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.LIFT_Session }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="NortonLifeLock">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.Norton_LifeLock }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        <div>
          <iframe
            frame-ancestors="self"
            src="https://my.norton.com"
            width="100%"
            id="pdf-viewer"
          >
          </iframe>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="MyHsa">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.MyHSA }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        <div>
          <iframe
            src="https://groupbenefitz.myhsaaccess.com/Home"
            width="100%"
            id="pdf-viewer"
          ></iframe>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="Carequest">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{ lang?.Care_Quest }}</h6>
        <i
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        <div>
          <iframe
            src="https://www.carequest.ca/co/groupbenefitz"
            width="100%"
            id="pdf-viewer"
          ></iframe>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          *ngIf="updatedWindowLenght > historyLength"
          id="previousButton"
          class="btn btn-sm btn-light"
          (click)="goBack()"
        >
          <b>{{ lang?.Previous_Page }}</b>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="cancelButton"
          data-bs-dismiss="modal"
          data-bs-toggle="modal"
        >
          <b>{{ lang?.Close }}</b>
        </button>
      </div>
    </div>
  </div>
</div>
